import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import ServiceGroupSelect from 'components/ServiceGroupSelect';
import ServicesSelect from 'components/ServicesSelect';

import { PackageEditTransportServices_data$key } from '__generated__/PackageEditTransportServices_data.graphql';
import TextField from 'components/TextField';
import PriceInput from 'components/PriceInput';

type Props = {
  data: PackageEditTransportServices_data$key;
};

const PackageEditTransportServices: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment PackageEditTransportServices_data on Query {
        ...ServiceGroupSelect_data
        ...ServicesSelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="services" title="Papildomos paslaugos">
      <Stack spacing={4}>
        <TextField
          fullWidth
          component={PriceInput}
          name="transferPrice"
          label="Pervežimo iš oro uosto kaina"
        />

        <ServiceGroupSelect data={data} />
        <ServicesSelect name="services" data={data} />
      </Stack>
    </Section>
  );
};

export default PackageEditTransportServices;
